import { licenceList } from 'common/constants';
import { RuleProps } from 'types/application';

export const SUPPORTING_DOCUMENTS = 'cancel-supporting-documents';

export const LICENCE_DETAILS = 'cancel-licence-details';

const excludeLicences = [
    'Newspaper Permit',
    'Film (Distribution/Exhibition) Licence',
    'TV Receive-Only System Licence',
    'Telecommunication Cable Detection Worker Licence',
    'Telecommunication Wiring Installer Class Licence',
    'Telecommunication Wiring Contractor Class Licence',
    'Exhibition of Telecommunication Equipment (without Frequency)',
    'Exhibition of Telecommunication Equipment (with Frequency)'
];

export const CANCEL_LICENCE_APPLICATION = [
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Licence Details',
        fieldList: [
            {
                id: 'licence-name',
                label: 'Licence Name',
                type: 'text',
                rule: {
                    hidden: true
                }
            },
            {
                id: 'licensee-nric',
                label: 'Licensee NRIC',
                type: 'text',
                rule: {
                    baseIds: [`${LICENCE_DETAILS}-licence-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && licenceList.some(lic => excludeLicences.includes(lic)));
                        return result;
                    }
                }
            },
            {
                id: 'registration-no-uen-other',
                label: 'Registration No Uen Other',
                type: 'text',
                rule: {
                    baseIds: [`${LICENCE_DETAILS}-licence-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && licenceList.some(lic => excludeLicences.includes(lic)));
                        return result;
                    }
                }
            },
            {
                id: 'licence-no',
                label: 'Licence No',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Cancellation Information',
        fieldList: [
            {
                id: 'effectiveDateOfCancellation',
                label: 'Effective Date Of Cancellation',
                type: 'text'
            },
            {
                id: 'cancellationReason',
                label: 'Cancellation Reason',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
